/*@ngInject*/
const OrganizationStateModel = function ($rootScope, $state) {

    var stateModelStorage,
        organizationId,
        organizationType,
        organizationForm,
        isVisibleForChat;

    this.init = function () {
        stateModelStorage = {};
        organizationId = null;
        organizationType = null;
        organizationForm = null;
        isVisibleForChat = true;
    };

    this.saveViewState = function (stateName, stateModel) {
        stateModelStorage[stateName] = _.cloneDeep(stateModel);
    };

    this.restoreViewState = function (stateName, viewModel) {
        var previousState = stateModelStorage[stateName];

        if(previousState) {
            _.merge(viewModel, previousState);
        }
    };

    this.getPreviousViewState = function (stateName) {
        return stateModelStorage[stateName];
    };

    this.savePreviousOrganization = function (id, type, formId) {
        organizationId = id;
        organizationType = type;
        organizationForm = formId;
    };

    this.getPreviousOrganization = function () {
        return {
            organizationId: organizationId,
            organizationType: organizationType,
            formId: organizationForm
        };
    };

    this.hasPreviousOrganization = function () {
        return organizationId !== null;
    };

    this.resetPreviousOrganization = function () {
        organizationId = null;
        organizationType = null;
        organizationForm = null;
        delete stateModelStorage[$state.name];
    };

    this.init();
};

angular.module('ums.configuration')
    .service('organizationStateModel', OrganizationStateModel);
